import { type FlagKey, type Flags } from '@core/context/FeatureFlagsContext';
import { type MonarchEditableAsset } from '@core/context/types';

import { type QuestionType } from '../blocks/edu-flow/components/Page/types';
import personalizationQuestionImportantFactors from './assets/personalizationQuestionImportantFactors';
import personalizationQuestionLevelOfEducation from './assets/personalizationQuestionLevelOfEducation';
import personalizationQuestionPursuingHigherEducation from './assets/personalizationQuestionPursuingHigherEducation';
import noPii from './assets/personalizationQuestionZip';
import securityBoost from './assets/securityBoost';

type GenerateAssetFunction = (question: QuestionType, asset: MonarchEditableAsset) => QuestionType;

const assetTypeToGenQuestionMap: Partial<Record<FlagKey, GenerateAssetFunction>> = {
  personalizationQuestionImportantFactors,
  personalizationQuestionLevelOfEducation,
  personalizationQuestionPursuingHigherEducation,
  noPii,
  securityBoost,
};

const generateAssetQuestion = (question: QuestionType, flags: Flags): QuestionType => {
  const monarchEditableAsset = flags[question?.monarchEditableAssetFlag as FlagKey] as MonarchEditableAsset;

  if (question?.monarchEditableAssetFlag === undefined) return question;

  const generateFunction = assetTypeToGenQuestionMap[question?.monarchEditableAssetFlag];

  if (!generateFunction) {
    console.error(`No asset generation function found for asset: ${question?.monarchEditableAssetFlag}`);
    return question;
  }

  return generateFunction(question, monarchEditableAsset);
};
export default generateAssetQuestion;
